import React, { useState, useCallback, useEffect, useContext } from 'react'
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import PageHeader from "../../../layouts/shared/headers/PageHeader/PageHeader";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import { Box, Button, CircularProgress, Grid, Paper, Stack, Typography, useMediaQuery} from "@mui/material";
import { LoadingButton } from '@mui/lab';
import * as yup from "yup";
import { ApiService } from 'app/servicesTwo/ApiService';
import CourseItem from "./CourseItem";
import { Link, useLocation } from "react-router-dom";
import { PermissionContext } from 'app/contexts/PermissionContext';
import JumboSearch from '@jumbo/components/JumboSearch';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import JumboSearchWithoutDebounce from "@jumbo/components/JumboSearchWithoutDebounce";

const validationSchema = yup.object({
    email: yup
        .string('Insira seu email')
        .email('Insira um email válido'),
    senha: yup
        .string('Insira sua senha'),
    nome: yup
        .string('Insira seu nome')
        .required('Preenchimento obrigatório'),
    cpf: yup
        .string(),
    rg: yup
        .string()
        .max(11, 'Deve ter no máximo 11 digitos'),
    data_nascimento: yup
        .date()
        .max(new Date(), 'Não é possivel incluir uma data futura')
        .required('Preenchimento obrigatório'),
    celular: yup
        .string()
});

const CourseList = () => {  
    const {theme} = useJumboTheme();
    const location = useLocation();
    const Swal = useSwalWrapper();
    
    const lg = useMediaQuery(theme.breakpoints.down('lg'));
    const layoutOptions = React.useMemo(() => ({
        sidebar: {
            sx: {
                [theme.breakpoints.up('lg')]: {
                    position: 'sticky',
                    zIndex: 5,
                    top: 96,
                    minHeight: 'auto',
                },
                [theme.breakpoints.down('lg')]: {
                    display: 'none',
                },
            }
        },
        wrapper: {
            sx: {
                alignItems: 'flex-start',
            }
        },
    }), [theme]);

    const [courses, setCourses] = useState(null)
    const [searchTerm, setSearchTerm] = useState(null)
    const [loading, setLoading] = useState(false)

    const { hasPermission } = useContext(PermissionContext);


    const getCourses = useCallback(async () => {
        try {
            ApiService.get('/cursos')
            .then((response) => {
              setCourses(response.data);
            })
            .catch((error) => {
              if (error.response) {
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('error', error.message);
                }
            })
        } catch (err) {
          console.log(err);
        }
    }, []);

    const searchCourses = useCallback(async (e) => {
        console.log('pesquisar', e)
        try {
            ApiService.get('/cursos', {params: {search: e}})
            .then((response) => {
                setCourses(response.data);
            })
            .catch((error) => {
              if (error.response) {
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('error', error.message);
                }
            })
        } catch (err) {
          console.log(err);
        }
    }, []);

    useEffect(() => {
    getCourses();
    }, []);

    useEffect(() => {
    console.log('atualizou')
    }, [setCourses, courses]);

    useEffect(() => {
        Swal.close();
    }, [location.pathname, Swal]);

    const classesWithThisCourse = courses?.map((course) => {
        return {
          ...course,
          turmasComEsteCurso: course.Turma?.length
        }
    })

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
    
            setTimeout(() => {
                searchCourses(searchTerm);
            }, 1000)
        }
    };

  return (
    <JumboContentLayout
        header={
            <PageHeader
                title={"Cursos"}
            />
        }
       
        layoutOptions={layoutOptions}
    >
        {
            lg && (
                <Stack spacing={2} direction={"row"} sx={{mb: 3, mt: -2}}>
                </Stack>
            )
        }
        <Paper sx={{p: '40px'}}>
            <Grid item xs={12} sx={{textAlign: 'center'}}> 
                <Link to="/app/novo-curso" style={{ textDecoration:'none', pointerEvents: !hasPermission('Cursos', 'criar') ? 'none' : '' }} state={{ backUrl: location.pathname }}>
                    <LoadingButton
                        color="success"
                        type="submit"
                        variant="contained"
                        size="large"
                        disabled={!hasPermission('Cursos', 'criar') ? true : false}
                        sx={{maxWidth: {md: '200px', mt: '1rem'}, marginBottom: '2rem'}}
                    >
                        Novo Curso
                    </LoadingButton>
                </Link>
            </Grid>

            <Typography 
                variant="h6" 
                sx={{fontWeight: '500', marginBottom: '1rem', marginLeft: '1rem'}}
            >
                Busque por nome do curso.
            </Typography>

            <Box
                display='flex'
                alignItems='center'
                gap='1rem'
                marginBottom='1rem'
                flexWrap='wrap'
                onKeyDown={(e) => {
                    handleKeyDown(e, searchTerm)
                }}
            >
            <Box display='flex' alignItems='center'>
                <JumboSearchWithoutDebounce
                    defaultValue={searchTerm}
                    onChange={(e) => setSearchTerm(e)}
                    placeholder='Digite o nome do curso aqui...'
                    sx={{
                        width: '440px',
                    }}
                /> 
            </Box>

            <Box display='flex' alignItems='center' gap='1rem'>
                <Button variant={'contained'} onClick={() => searchCourses(searchTerm)}>
                    Filtrar
                </Button>
            </Box>
            </Box>
                
                <React.Fragment>
                    
                    {
                        loading
                            ?(
                                <Box display='flex' justifyContent='center'>
                                    <CircularProgress />
                                </Box>
                            )
                        :
                        <>
                            {  
                                classesWithThisCourse && classesWithThisCourse.filter((course) => course.tipo_curso !== 'antigo').map((course, key) => (
                                        <CourseItem item={course} setCourses={(data) => setCourses([...data])} courses={courses} key={key}/>
                                    ))
                            }
                            {classesWithThisCourse && classesWithThisCourse.length === 0 && (
                                <Typography>Sem resultados correspondentes</Typography>
                            )}
                        </>
                    }
                </React.Fragment>
        </Paper>
    </JumboContentLayout>
  )
}

export default CourseList